import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listInventoryLocations } from './api';
import {
  LIST_INVENTORY_LOCATIONS_REQUEST,
  INVENTORY_LOCATION_LIST_REQUESTING,
  LIST_INVENTORY_LOCATIONS_SUCCESS,
  RESET_INVENTORY_LOCATION_ISFETCHING
} from './constants';

function* list() {
  try {
    yield call(removeAPIError);
    yield put({ type: INVENTORY_LOCATION_LIST_REQUESTING });
    const response = yield call(listInventoryLocations);
    yield put({
      type: LIST_INVENTORY_LOCATIONS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_INVENTORY_LOCATION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  // Need take latest so that gets multiple collections on a page
  yield takeLatest(LIST_INVENTORY_LOCATIONS_REQUEST, list);
}

export default function* inventoryLocationSagas() {
  yield all([watchList()]);
}
